// import React, { useState } from "react";
// import {
//   User,
//   Users,
//   Calendar,
//   CheckCircle,
//   XCircle,
//   Clock,
//   AlertCircle,
//   TrendingUp,
//   FileText,
// } from "lucide-react";

// const ManagerDashboard = () => {
//   // Sample manager data
//   const [managerData] = useState({
//     name: "Hih Kumar",
//     empId: "96585",
//     email: "hihr@yopmail.com",
//     department: "IT Department",
//     designation: "Vice President",
//     teamSize: 8,
//   });

//   // Team stats
//   const [teamStats] = useState({
//     totalTeamMembers: 8,
//     presentToday: 7,
//     onLeaveToday: 1,
//     lateToday: 0,
//     teamAttendanceRate: 92,
//     pendingLeaveRequests: 2,
//     pendingAttendanceCorrections: 1,
//   });

//   // Pending leave requests
//   const [pendingLeaves] = useState([
//     {
//       id: 1,
//       empName: "Divanshi Kapoor",
//       empId: "25693",
//       leaveType: "Sick Leave",
//       fromDate: "15/10/2024",
//       toDate: "16/10/2024",
//       days: 2,
//       reason: "Medical checkup",
//       appliedOn: "14/10/2024",
//     },
//     {
//       id: 2,
//       empName: "Mohd Hashim",
//       empId: "5693",
//       leaveType: "Casual Leave",
//       fromDate: "20/10/2024",
//       toDate: "20/10/2024",
//       days: 1,
//       reason: "Personal work",
//       appliedOn: "15/10/2024",
//     },
//   ]);

//   // Team members quick view
//   const [teamMembers] = useState([
//     {
//       id: 1,
//       name: "Divanshi Kapoor",
//       empId: "25693",
//       designation: "Software Engineer",
//       status: "On Leave",
//       statusColor: "text-red-600",
//     },
//     {
//       id: 2,
//       name: "Mohd Hashim",
//       empId: "5693",
//       designation: "Senior Developer",
//       status: "Present",
//       statusColor: "text-green-600",
//     },
//     {
//       id: 3,
//       name: "Testing Kumar",
//       empId: "9658",
//       designation: "QA Engineer",
//       status: "Present",
//       statusColor: "text-green-600",
//     },
//     {
//       id: 4,
//       name: "Kumari Kumar",
//       empId: "41799",
//       designation: "Developer",
//       status: "Present",
//       statusColor: "text-green-600",
//     },
//   ]);

//   const handleApprove = (leaveId) => {
//     console.log("Approved leave:", leaveId);
//   };

//   const handleReject = (leaveId) => {
//     console.log("Rejected leave:", leaveId);
//   };

//   return (
//     <div className="min-h-screen  ">
//       {/* Header */}

//       <div className="max-w-12xl mx-auto px-6 py-8">
//         {/* Welcome Section */}
//         <div className="mb-8">
//           <h1 className="text-3xl font-bold text-gray-800 mb-2">
//             Welcome back, {managerData.name}!
//           </h1>
//           <p className="text-gray-600">
//             Manage your team of {managerData.teamSize} members
//           </p>
//         </div>

//         {/* Stats Cards Row 1 */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
//           {/* Total Team Members */}
//           <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-lg shadow-sm border border-indigo-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center">
//                 <Users className="w-6 h-6 text-white" />
//               </div>
//               <span className="text-3xl font-bold text-indigo-700">
//                 {teamStats.totalTeamMembers}
//               </span>
//             </div>
//             <h3 className="text-sm font-semibold text-indigo-900 mb-1">
//               Total Team Members
//             </h3>
//             <p className="text-xs text-indigo-700">Under your management</p>
//           </div>

//           {/* Present Today */}
//           <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg shadow-sm border border-green-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
//                 <CheckCircle className="w-6 h-6 text-white" />
//               </div>
//               <span className="text-3xl font-bold text-green-700">
//                 {teamStats.presentToday}
//               </span>
//             </div>
//             <h3 className="text-sm font-semibold text-green-900 mb-1">
//               Present Today
//             </h3>
//             <p className="text-xs text-green-700">Active team members</p>
//           </div>

//           {/* On Leave Today */}
//           <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg shadow-sm border border-red-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
//                 <Calendar className="w-6 h-6 text-white" />
//               </div>
//               <span className="text-3xl font-bold text-red-700">
//                 {teamStats.onLeaveToday}
//               </span>
//             </div>
//             <h3 className="text-sm font-semibold text-red-900 mb-1">
//               On Leave Today
//             </h3>
//             <p className="text-xs text-red-700">Team members absent</p>
//           </div>

//           {/* Team Attendance Rate */}
//           <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-lg shadow-sm border border-sky-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-sky-600 rounded-full flex items-center justify-center">
//                 <TrendingUp className="w-6 h-6 text-white" />
//               </div>
//               <span className="text-3xl font-bold text-sky-700">
//                 {teamStats.teamAttendanceRate}%
//               </span>
//             </div>
//             <h3 className="text-sm font-semibold text-sky-900 mb-1">
//               Attendance Rate
//             </h3>
//             <p className="text-xs text-sky-700">This month average</p>
//           </div>
//         </div>

//         {/* Pending Actions Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//           {/* Pending Leave Requests */}
//           <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-lg shadow-sm border border-yellow-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center">
//                   <AlertCircle className="w-6 h-6 text-white" />
//                 </div>
//                 <div>
//                   <h3 className="text-lg font-semibold text-yellow-900">
//                     Pending Leave Requests
//                   </h3>
//                   <p className="text-xs text-yellow-700">
//                     Awaiting your approval
//                   </p>
//                 </div>
//               </div>
//               <span className="text-3xl font-bold text-yellow-700">
//                 {teamStats.pendingLeaveRequests}
//               </span>
//             </div>
//             <button className="w-full bg-yellow-600 hover:bg-yellow-700 text-white font-medium py-2 px-4 rounded-lg transition">
//               Review Requests
//             </button>
//           </div>

//           {/* Pending Attendance Corrections */}
//           <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg shadow-sm border border-orange-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center">
//                   <Clock className="w-6 h-6 text-white" />
//                 </div>
//                 <div>
//                   <h3 className="text-lg font-semibold text-orange-900">
//                     Attendance Corrections
//                   </h3>
//                   <p className="text-xs text-orange-700">Pending review</p>
//                 </div>
//               </div>
//               <span className="text-3xl font-bold text-orange-700">
//                 {teamStats.pendingAttendanceCorrections}
//               </span>
//             </div>
//             <button className="w-full bg-orange-600 hover:bg-orange-700 text-white font-medium py-2 px-4 rounded-lg transition">
//               Review Corrections
//             </button>
//           </div>
//         </div>

//         {/* Pending Leave Requests Section */}
//         <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-lg font-semibold text-gray-800 flex items-center">
//               <FileText className="w-5 h-5 mr-2 text-indigo-600" />
//               Recent Leave Requests
//             </h2>
//             <span className="bg-red-100 text-red-800 text-xs font-semibold px-3 py-1 rounded-full">
//               {pendingLeaves.length} Pending
//             </span>
//           </div>
//           <div className="space-y-4">
//             {pendingLeaves.map((leave) => (
//               <div
//                 key={leave.id}
//                 className="border rounded-lg p-4 hover:bg-gray-50 transition"
//               >
//                 <div className="flex items-start justify-between mb-3">
//                   <div className="flex items-start space-x-3">
//                     <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
//                       <User className="w-5 h-5 text-indigo-600" />
//                     </div>
//                     <div>
//                       <h3 className="font-semibold text-gray-800">
//                         {leave.empName}
//                       </h3>
//                       <p className="text-xs text-gray-500">
//                         Emp ID: {leave.empId} • Applied on {leave.appliedOn}
//                       </p>
//                     </div>
//                   </div>
//                   <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-3 py-1 rounded-full border border-yellow-300">
//                     Pending
//                   </span>
//                 </div>
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3 text-sm">
//                   <div>
//                     <p className="text-xs text-gray-500">Leave Type</p>
//                     <p className="font-medium text-gray-800">
//                       {leave.leaveType}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-xs text-gray-500">From Date</p>
//                     <p className="font-medium text-gray-800">
//                       {leave.fromDate}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-xs text-gray-500">To Date</p>
//                     <p className="font-medium text-gray-800">{leave.toDate}</p>
//                   </div>
//                   <div>
//                     <p className="text-xs text-gray-500">Total Days</p>
//                     <p className="font-medium text-gray-800">
//                       {leave.days} day{leave.days > 1 ? "s" : ""}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="mb-3">
//                   <p className="text-xs text-gray-500 mb-1">Reason</p>
//                   <p className="text-sm text-gray-700">{leave.reason}</p>
//                 </div>
//                 <div className="flex space-x-3">
//                   <button
//                     onClick={() => handleApprove(leave.id)}
//                     className="flex-1 bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center"
//                   >
//                     <CheckCircle className="w-4 h-4 mr-2" />
//                     Approve
//                   </button>
//                   <button
//                     onClick={() => handleReject(leave.id)}
//                     className="flex-1 bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center"
//                   >
//                     <XCircle className="w-4 h-4 mr-2" />
//                     Reject
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//           <div className="mt-4 text-center">
//             <button className="text-indigo-600 hover:text-indigo-700 text-sm font-medium">
//               View All Leave Requests →
//             </button>
//           </div>
//         </div>

//         {/* Team Members Overview */}
//         <div className="bg-white rounded-lg shadow-sm border p-6">
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-lg font-semibold text-gray-800 flex items-center">
//               <Users className="w-5 h-5 mr-2 text-indigo-600" />
//               Team Members
//             </h2>
//             <button className="text-indigo-600 hover:text-indigo-700 text-sm font-medium">
//               View All →
//             </button>
//           </div>
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead>
//                 <tr className="border-b">
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     EMP ID
//                   </th>
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     Name
//                   </th>
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     Designation
//                   </th>
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     Status
//                   </th>
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     Action
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {teamMembers.map((member) => (
//                   <tr
//                     key={member.id}
//                     className="border-b hover:bg-gray-50 transition"
//                   >
//                     <td className="py-3 px-4 text-sm text-gray-800">
//                       {member.empId}
//                     </td>
//                     <td className="py-3 px-4 text-sm font-medium text-gray-800">
//                       {member.name}
//                     </td>
//                     <td className="py-3 px-4 text-sm text-gray-600">
//                       {member.designation}
//                     </td>
//                     <td className="py-3 px-4">
//                       <span
//                         className={`text-sm font-medium ${member.statusColor}`}
//                       >
//                         {member.status}
//                       </span>
//                     </td>
//                     <td className="py-3 px-4">
//                       <button className="text-indigo-600 hover:text-indigo-700 text-sm font-medium">
//                         View Profile
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ManagerDashboard;

import React, { useState, useEffect } from "react";
import {
  Users,
  Calendar,
  CheckCircle,
  TrendingUp,
  FileText,
  Plus,
  Clock,
  ArrowRight,
  User,
  XCircle,
  Loader2,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  getTeamLeaveRequests,
  getTeamEmployees,
  getTeamMembers,
} from "../../services/hrms.service";

const ManagerDashboard = () => {
  const navigate = useNavigate();

  const [managerData, setManagerData] = useState({
    name: "Manager",
    empId: "",
    email: "",
    department: "",
    designation: "",
    teamSize: 0,
  });

  const [teamStats, setTeamStats] = useState({
    totalTeamMembers: 0,
    presentToday: 0,
    onLeaveToday: 0,
    totalWorkingHours: 320,
    expectedHours: 352,
    overtimeHours: 12,
    teamAttendanceRate: 92,
    pendingLeaveRequests: 0,
  });

  const [pendingLeaves, setPendingLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingManager, setLoadingManager] = useState(true);
  const [error, setError] = useState(null);

  const [teamMembers, setTeamMembers] = useState([]);
  const [loadingTeamMembers, setLoadingTeamMembers] = useState(false);

  const [showAddEmployeeModal, setShowAddEmployeeModal] = useState(false);
  const [newEmployee, setNewEmployee] = useState({
    empId: "",
    name: "",
    email: "",
    phone: "",
    designation: "",
    department: "IT Department",
  });

  const handleAddEmployeeChange = (e) => {
    setNewEmployee({
      ...newEmployee,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddEmployeeSubmit = (e) => {
    e.preventDefault();
    // Add API call here
    setShowAddEmployeeModal(false);
    alert("Employee added successfully!");
  };

  // Fetch dashboard data on component mount
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        setLoadingManager(true);
        setError(null);

        // Fetch manager profile
        // try {
        //   const managerResponse = await getManagerProfile();
        //   if (managerResponse.status === 1 && managerResponse.data) {
        //     const manager = managerResponse.data;
        //     setManagerData({
        //       name:
        //         manager.employee_name ||
        //         `${manager.first_name || ""} ${
        //           manager.last_name || ""
        //         }`.trim() ||
        //         "Manager",
        //       empId: manager.employee_id || "",
        //       email: manager.email || "",
        //       department: manager.department || "",
        //       designation: manager.designation || "",
        //       teamSize: 0, // Will be updated from team data
        //     });
        //   }
        // } catch (error) {
        //   console.error("Error fetching manager profile:", error);
        //   // Keep default values if API fails
        // } finally {
        //   setLoadingManager(false);
        // }

        // Fetch team leave requests
        const leaveResponse = await getTeamLeaveRequests(1, 10, "Pending");
        let pendingLeavesData = [];
        if (leaveResponse.status === 1 && leaveResponse.data) {
          pendingLeavesData = leaveResponse.data.map((leave) => ({
            id: leave.id,
            empName:
              leave.employee_name ||
              `${leave.first_name || ""} ${leave.last_name || ""}`.trim() ||
              "N/A",
            empId: leave.employee_id || "N/A",
            leaveType: leave.leave_type_name || leave.leave_type || "N/A",
            fromDate: leave.start_date
              ? new Date(leave.start_date).toLocaleDateString()
              : "N/A",
            toDate: leave.end_date
              ? new Date(leave.end_date).toLocaleDateString()
              : "N/A",
            days: leave.total_days || 1,
            reason: leave.reason || "",
            appliedOn: leave.created_at
              ? new Date(leave.created_at).toLocaleDateString()
              : "N/A",
          }));
          setPendingLeaves(pendingLeavesData);
        }

        // Fetch team employees to calculate stats
        const teamResponse = await getTeamEmployees(1, 100);
        let teamMembersData = [];
        if (teamResponse.status === 1 && teamResponse.data) {
          teamMembersData = teamResponse.data;
        }

        // Fetch team members for the table
        setLoadingTeamMembers(true);
        try {
          const teamMembersResponse = await getTeamMembers(1, 10);
          if (teamMembersResponse.status === 1 && teamMembersResponse.data) {
            const formattedTeamMembers = teamMembersResponse.data.map(
              (member) => ({
                id: member.id,
                name:
                  member.employee_name ||
                  `${member.first_name || ""} ${
                    member.last_name || ""
                  }`.trim() ||
                  "N/A",
                empId: member.employee_id || "N/A",
                designation: member.designation || "N/A",
                status: member.status || "Present",
                statusColor:
                  member.status === "On Leave"
                    ? "text-red-600"
                    : "text-green-600",
              })
            );
            setTeamMembers(formattedTeamMembers);
          }
        } catch (error) {
          console.error("Error fetching team members:", error);
        } finally {
          setLoadingTeamMembers(false);
        }

        // Calculate stats
        const totalTeamMembers = teamMembersData.length;
        const presentToday = teamMembersData.filter(
          (member) =>
            member.status === "Present" ||
            member.attendance_status === "Present"
        ).length;
        const onLeaveToday = teamMembersData.filter(
          (member) =>
            member.status === "On Leave" || member.leave_status === "On Leave"
        ).length;

        setTeamStats((prevStats) => ({
          ...prevStats,
          totalTeamMembers,
          presentToday,
          onLeaveToday,
          pendingLeaveRequests: pendingLeavesData.length,
        }));

        // Update manager data with team size
        setManagerData((prevData) => ({
          ...prevData,
          teamSize: totalTeamMembers,
        }));
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
        setError("Failed to load dashboard data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const handleApprove = (leaveId) => {
    // Add API call here
    alert("Leave approved successfully!");
  };

  const handleReject = (leaveId) => {
    // Add API call here
    alert("Leave rejected successfully!");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-indigo-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Error Loading Dashboard
          </h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-12xl mx-auto px-6 py-8">
        {/* Welcome Section */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Welcome back, {loadingManager ? "..." : managerData.name}!
          </h1>
          <p className="text-gray-600">
            Manage your team of {teamStats.totalTeamMembers} members
          </p>
        </div>

        {/* Stats Cards Row 1 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {/* Total Team Members - WITH ADD BUTTON */}
          <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-lg shadow-sm border border-indigo-200 p-6 relative">
            <button
              onClick={() => setShowAddEmployeeModal(true)}
              className="absolute top-4 right-4 w-8 h-8 bg-indigo-600 hover:bg-indigo-700 rounded-full flex items-center justify-center transition"
              title="Add Employee"
            >
              <Plus className="w-5 h-5 text-white" />
            </button>
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center">
                <Users className="w-6 h-6 text-white" />
              </div>
              {/* <span className="text-3xl font-bold text-indigo-700">
                {teamStats.totalTeamMembers}
              </span> */}
            </div>
            <h3 className="text-sm font-semibold text-indigo-900 mb-1">
              Add Team Members
            </h3>
            <p className="text-xs text-indigo-700">Under your management</p>
          </div>

          {/* Present Today */}
          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg shadow-sm border border-green-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
                <CheckCircle className="w-6 h-6 text-white" />
              </div>
              <span className="text-3xl font-bold text-green-700">
                {teamStats.presentToday}
              </span>
            </div>
            <h3 className="text-sm font-semibold text-green-900 mb-1">
              Present Today
            </h3>
            <p className="text-xs text-green-700">Active team members</p>
          </div>

          {/* On Leave Today */}
          <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg shadow-sm border border-red-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                <Calendar className="w-6 h-6 text-white" />
              </div>
              <span className="text-3xl font-bold text-red-700">
                {teamStats.onLeaveToday}
              </span>
            </div>
            <h3 className="text-sm font-semibold text-red-900 mb-1">
              On Leave Today
            </h3>
            <p className="text-xs text-red-700">Team members absent</p>
          </div>

          {/* Team Working Hours (NEW - Replaced Attendance Rate) */}
          {/* <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg shadow-sm border border-purple-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center">
                <Clock className="w-6 h-6 text-white" />
              </div>
              <span className="text-3xl font-bold text-purple-700">
                {teamStats.totalWorkingHours}h
              </span>
            </div>
            <h3 className="text-sm font-semibold text-purple-900 mb-1">
              Total Working Hours
            </h3>
            <p className="text-xs text-purple-700">
              +{teamStats.overtimeHours}h overtime this month
            </p>
          </div> */}
          <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg shadow-sm border border-red-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center">
                <Calendar className="w-6 h-6 text-white" />
              </div>
              <span className="text-3xl font-bold text-purple-700">
                {teamStats.onLeaveToday}
              </span>
            </div>
            <h3 className="text-sm font-semibold text-purple-900 mb-1">
              Absent Today
            </h3>
            <p className="text-xs text-purple-700">Team members absent</p>
          </div>
        </div>

        {/* Pending Actions Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {/* Pending Leave Requests - CLICKABLE CARD */}
          <div
            onClick={() => navigate("/manager/leave-requests")}
            className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-lg shadow-sm border border-yellow-200 p-6 cursor-pointer hover:shadow-md transition"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-yellow-900">
                    Pending Leave Requests
                  </h3>
                  <p className="text-xs text-yellow-700">
                    Awaiting your approval
                  </p>
                </div>
              </div>
              <span className="text-3xl font-bold text-yellow-700">
                {teamStats.pendingLeaveRequests}
              </span>
            </div>
            <button className="w-full bg-yellow-600 hover:bg-yellow-700 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center">
              Review Requests
              <ArrowRight className="w-4 h-4 ml-2" />
            </button>
          </div>

          {/* Team Attendance Rate (Moved from above) */}
          <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-lg shadow-sm border border-sky-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-sky-600 rounded-full flex items-center justify-center">
                  <TrendingUp className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-sky-900">
                    Team Attendance Rate
                  </h3>
                  <p className="text-xs text-sky-700">Monthly average</p>
                </div>
              </div>
              <span className="text-3xl font-bold text-sky-700">
                {teamStats.teamAttendanceRate}%
              </span>
            </div>
            <div className="w-full bg-sky-200 rounded-full h-2">
              <div
                className="bg-sky-600 h-2 rounded-full"
                style={{ width: `${teamStats.teamAttendanceRate}%` }}
              ></div>
            </div>
          </div>
        </div>

        {/* Pending Leave Requests Section */}
        <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-gray-800 flex items-center">
              <FileText className="w-5 h-5 mr-2 text-indigo-600" />
              Recent Leave Requests
            </h2>
            <span className="bg-red-100 text-red-800 text-xs font-semibold px-3 py-1 rounded-full">
              {pendingLeaves.length} Pending
            </span>
          </div>
          <div className="space-y-4">
            {pendingLeaves.slice(0, 2).map((leave) => (
              <div
                key={leave.id}
                className="border rounded-lg p-4 hover:bg-gray-50 transition"
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-start space-x-3">
                    <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <User className="w-5 h-5 text-indigo-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800">
                        {leave.empName}
                      </h3>
                      <p className="text-xs text-gray-500">
                        Emp ID: {leave.empId} • Applied on {leave.appliedOn}
                      </p>
                    </div>
                  </div>
                  <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-3 py-1 rounded-full border border-yellow-300">
                    Pending
                  </span>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3 text-sm">
                  <div>
                    <p className="text-xs text-gray-500">Leave Type</p>
                    <p className="font-medium text-gray-800">
                      {leave.leaveType}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">From Date</p>
                    <p className="font-medium text-gray-800">
                      {leave.fromDate}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">To Date</p>
                    <p className="font-medium text-gray-800">{leave.toDate}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Total Days</p>
                    <p className="font-medium text-gray-800">
                      {leave.days} day{leave.days > 1 ? "s" : ""}
                    </p>
                  </div>
                </div>
                <div className="mb-3">
                  <p className="text-xs text-gray-500 mb-1">Reason</p>
                  <p className="text-sm text-gray-700">{leave.reason}</p>
                </div>
                <div className="flex space-x-3">
                  <button
                    onClick={() => handleApprove(leave.id)}
                    className="flex-1 bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center"
                  >
                    <CheckCircle className="w-4 h-4 mr-2" />
                    Approve
                  </button>
                  <button
                    onClick={() => handleReject(leave.id)}
                    className="flex-1 bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center"
                  >
                    <XCircle className="w-4 h-4 mr-2" />
                    Reject
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-4 text-center">
            <button
              onClick={() => navigate("/manager/leave-requests")}
              className="text-indigo-600 hover:text-indigo-700 text-sm font-medium flex items-center justify-center mx-auto"
            >
              View All Leave Requests
              <ArrowRight className="w-4 h-4 ml-1" />
            </button>
          </div>
        </div>

        {/* Team Members Overview */}
        <div className="bg-white rounded-lg shadow-sm border p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-gray-800 flex items-center">
              <Users className="w-5 h-5 mr-2 text-indigo-600" />
              Team Members
            </h2>
            <button
              onClick={() => navigate("/manager/team-members")}
              className="text-indigo-600 hover:text-indigo-700 text-sm font-medium flex items-center"
            >
              View All
              <ArrowRight className="w-4 h-4 ml-1" />
            </button>
          </div>
          <div className="overflow-x-auto">
            {loadingTeamMembers ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="w-6 h-6 animate-spin text-indigo-600 mr-2" />
                <span className="text-gray-600">Loading team members...</span>
              </div>
            ) : teamMembers.length === 0 ? (
              <div className="text-center py-8">
                <p className="text-gray-500">No team members found</p>
              </div>
            ) : (
              <table className="w-full">
                <thead>
                  <tr className="border-b">
                    <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
                      EMP ID
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
                      Name
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
                      Designation
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
                      Status
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {teamMembers.slice(0, 4).map((member) => (
                    <tr
                      key={member.id}
                      className="border-b hover:bg-gray-50 transition"
                    >
                      <td className="py-3 px-4 text-sm text-gray-800">
                        {member.empId}
                      </td>
                      <td className="py-3 px-4 text-sm font-medium text-gray-800">
                        {member.name}
                      </td>
                      <td className="py-3 px-4 text-sm text-gray-600">
                        {member.designation}
                      </td>
                      <td className="py-3 px-4">
                        <span
                          className={`text-sm font-medium ${member.statusColor}`}
                        >
                          {member.status}
                        </span>
                      </td>
                      <td className="py-3 px-4">
                        <button
                          onClick={() =>
                            navigate(`/manager/employee/${member.id}`)
                          }
                          className="text-indigo-600 hover:text-indigo-700 text-sm font-medium"
                        >
                          View Profile
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      {/* Add Employee Modal (Keep this as modal - it's a quick action) */}
      {showAddEmployeeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-gray-800">
                Add New Employee
              </h3>
              <button
                onClick={() => setShowAddEmployeeModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <XCircle className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleAddEmployeeSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Employee ID *
                </label>
                <input
                  type="text"
                  name="empId"
                  value={newEmployee.empId}
                  onChange={handleAddEmployeeChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Enter employee ID"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Employee Name *
                </label>
                <input
                  type="text"
                  name="name"
                  value={newEmployee.name}
                  onChange={handleAddEmployeeChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Enter full name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email ID *
                </label>
                <input
                  type="email"
                  name="email"
                  value={newEmployee.email}
                  onChange={handleAddEmployeeChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Enter email address"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={newEmployee.phone}
                  onChange={handleAddEmployeeChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Enter phone number"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Designation *
                </label>
                <input
                  type="text"
                  name="designation"
                  value={newEmployee.designation}
                  onChange={handleAddEmployeeChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Enter designation"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Department *
                </label>
                <input
                  type="text"
                  name="department"
                  value={newEmployee.department}
                  onChange={handleAddEmployeeChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Enter department"
                />
              </div>
              <div className="flex space-x-3 pt-2">
                <button
                  type="button"
                  onClick={() => setShowAddEmployeeModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 font-medium transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-medium transition"
                >
                  Add Employee
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagerDashboard;
// import React, { useState } from "react";
// import {
//   User,
//   Users,
//   Calendar,
//   CheckCircle,
//   XCircle,
//   Clock,
//   AlertCircle,
//   TrendingUp,
//   FileText,
//   Plus,
//   X,
// } from "lucide-react";

// const ManagerDashboard = () => {
//   // Sample manager data
//   const [managerData] = useState({
//     name: "Hih Kumar",
//     empId: "96585",
//     email: "hihr@yopmail.com",
//     department: "IT Department",
//     designation: "Vice President",
//     teamSize: 8,
//   });

//   // Team stats
//   const [teamStats, setTeamStats] = useState({
//     totalTeamMembers: 8,
//     presentToday: 7,
//     onLeaveToday: 1,
//     lateToday: 0,
//     teamAttendanceRate: 92,
//     pendingLeaveRequests: 2,
//     pendingAttendanceCorrections: 1,
//   });

//   // Pending leave requests
//   const [pendingLeaves, setPendingLeaves] = useState([
//     {
//       id: 1,
//       empName: "Divanshi Kapoor",
//       empId: "25693",
//       leaveType: "Sick Leave",
//       fromDate: "15/10/2024",
//       toDate: "16/10/2024",
//       days: 2,
//       reason: "Medical checkup",
//       appliedOn: "14/10/2024",
//     },
//     {
//       id: 2,
//       empName: "Mohd Hashim",
//       empId: "5693",
//       leaveType: "Casual Leave",
//       fromDate: "20/10/2024",
//       toDate: "20/10/2024",
//       days: 1,
//       reason: "Personal work",
//       appliedOn: "15/10/2024",
//     },
//   ]);

//   // Team members
//   const [teamMembers, setTeamMembers] = useState([
//     {
//       id: 1,
//       name: "Divanshi Kapoor",
//       empId: "25693",
//       email: "divanshi@company.com",
//       phone: "+91 9876543210",
//       designation: "Software Engineer",
//       department: "IT Department",
//       status: "On Leave",
//       statusColor: "text-red-600",
//       joiningDate: "15/01/2024",
//     },
//     {
//       id: 2,
//       name: "Mohd Hashim",
//       empId: "5693",
//       email: "mohd@company.com",
//       phone: "+91 9876543211",
//       designation: "Senior Developer",
//       department: "IT Department",
//       status: "Present",
//       statusColor: "text-green-600",
//       joiningDate: "10/03/2023",
//     },
//     {
//       id: 3,
//       name: "Testing Kumar",
//       empId: "9658",
//       email: "testing@company.com",
//       phone: "+91 9876543212",
//       designation: "QA Engineer",
//       department: "IT Department",
//       status: "Present",
//       statusColor: "text-green-600",
//       joiningDate: "20/06/2023",
//     },
//     {
//       id: 4,
//       name: "Kumari Kumar",
//       empId: "41799",
//       email: "kumari@company.com",
//       phone: "+91 9876543213",
//       designation: "Developer",
//       department: "IT Department",
//       status: "Present",
//       statusColor: "text-green-600",
//       joiningDate: "05/02/2024",
//     },
//   ]);

//   // Modal states
//   const [showAddEmployeeModal, setShowAddEmployeeModal] = useState(false);
//   const [showLeaveRequestsModal, setShowLeaveRequestsModal] = useState(false);
//   const [showTeamMembersModal, setShowTeamMembersModal] = useState(false);
//   const [showProfileModal, setShowProfileModal] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   // Form data for adding employee
//   const [newEmployee, setNewEmployee] = useState({
//     empId: "",
//     name: "",
//     email: "",
//     phone: "",
//     designation: "",
//     department: "IT Department",
//   });

//   // Handle add employee form change
//   const handleAddEmployeeChange = (e) => {
//     setNewEmployee({
//       ...newEmployee,
//       [e.target.name]: e.target.value,
//     });
//   };

//   // Handle add employee submit
//   const handleAddEmployeeSubmit = (e) => {
//     e.preventDefault();
//     const employee = {
//       id: teamMembers.length + 1,
//       name: newEmployee.name,
//       empId: newEmployee.empId,
//       email: newEmployee.email,
//       phone: newEmployee.phone,
//       designation: newEmployee.designation,
//       department: newEmployee.department,
//       status: "Present",
//       statusColor: "text-green-600",
//       joiningDate: new Date().toLocaleDateString(),
//     };
//     setTeamMembers([...teamMembers, employee]);
//     setTeamStats({
//       ...teamStats,
//       totalTeamMembers: teamStats.totalTeamMembers + 1,
//     });
//     setNewEmployee({
//       empId: "",
//       name: "",
//       email: "",
//       phone: "",
//       designation: "",
//       department: "IT Department",
//     });
//     setShowAddEmployeeModal(false);
//     alert("Employee added successfully!");
//   };

//   // Handle leave approve
//   const handleApprove = (leaveId) => {
//     setPendingLeaves(pendingLeaves.filter((leave) => leave.id !== leaveId));
//     setTeamStats({
//       ...teamStats,
//       pendingLeaveRequests: teamStats.pendingLeaveRequests - 1,
//     });
//     alert("Leave approved successfully!");
//   };

//   // Handle leave reject
//   const handleReject = (leaveId) => {
//     setPendingLeaves(pendingLeaves.filter((leave) => leave.id !== leaveId));
//     setTeamStats({
//       ...teamStats,
//       pendingLeaveRequests: teamStats.pendingLeaveRequests - 1,
//     });
//     alert("Leave rejected successfully!");
//   };

//   // Handle view profile
//   const handleViewProfile = (employee) => {
//     setSelectedEmployee(employee);
//     setShowProfileModal(true);
//   };

//   return (
//     <div className="min-h-screen">
//       <div className="max-w-12xl mx-auto px-6 py-8">
//         {/* Welcome Section */}
//         <div className="mb-8">
//           <h1 className="text-3xl font-bold text-gray-800 mb-2">
//             Welcome back, {managerData.name}!
//           </h1>
//           <p className="text-gray-600">
//             Manage your team of {teamStats.totalTeamMembers} members
//           </p>
//         </div>

//         {/* Stats Cards Row 1 */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
//           {/* Total Team Members - WITH ADD BUTTON */}
//           <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-lg shadow-sm border border-indigo-200 p-6 relative">
//             <button
//               onClick={() => setShowAddEmployeeModal(true)}
//               className="absolute top-4 right-4 w-8 h-8 bg-indigo-600 hover:bg-indigo-700 rounded-full flex items-center justify-center transition"
//               title="Add Employee"
//             >
//               <Plus className="w-5 h-5 text-white" />
//             </button>
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center">
//                 <Users className="w-6 h-6 text-white" />
//               </div>
//               <span className="text-3xl font-bold text-indigo-700">
//                 {teamStats.totalTeamMembers}
//               </span>
//             </div>
//             <h3 className="text-sm font-semibold text-indigo-900 mb-1">
//               Total Team Members
//             </h3>
//             <p className="text-xs text-indigo-700">Under your management</p>
//           </div>

//           {/* Present Today */}
//           <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg shadow-sm border border-green-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
//                 <CheckCircle className="w-6 h-6 text-white" />
//               </div>
//               <span className="text-3xl font-bold text-green-700">
//                 {teamStats.presentToday}
//               </span>
//             </div>
//             <h3 className="text-sm font-semibold text-green-900 mb-1">
//               Present Today
//             </h3>
//             <p className="text-xs text-green-700">Active team members</p>
//           </div>

//           {/* On Leave Today */}
//           <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg shadow-sm border border-red-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
//                 <Calendar className="w-6 h-6 text-white" />
//               </div>
//               <span className="text-3xl font-bold text-red-700">
//                 {teamStats.onLeaveToday}
//               </span>
//             </div>
//             <h3 className="text-sm font-semibold text-red-900 mb-1">
//               On Leave Today
//             </h3>
//             <p className="text-xs text-red-700">Team members absent</p>
//           </div>

//           {/* Team Attendance Rate */}
//           <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-lg shadow-sm border border-sky-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-sky-600 rounded-full flex items-center justify-center">
//                 <TrendingUp className="w-6 h-6 text-white" />
//               </div>
//               <span className="text-3xl font-bold text-sky-700">
//                 {teamStats.teamAttendanceRate}%
//               </span>
//             </div>
//             <h3 className="text-sm font-semibold text-sky-900 mb-1">
//               Attendance Rate
//             </h3>
//             <p className="text-xs text-sky-700">This month average</p>
//           </div>
//         </div>

//         {/* Pending Actions Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//           {/* Pending Leave Requests */}
//           <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-lg shadow-sm border border-yellow-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center">
//                   <AlertCircle className="w-6 h-6 text-white" />
//                 </div>
//                 <div>
//                   <h3 className="text-lg font-semibold text-yellow-900">
//                     Pending Leave Requests
//                   </h3>
//                   <p className="text-xs text-yellow-700">
//                     Awaiting your approval
//                   </p>
//                 </div>
//               </div>
//               <span className="text-3xl font-bold text-yellow-700">
//                 {teamStats.pendingLeaveRequests}
//               </span>
//             </div>
//             <button
//               onClick={() => setShowLeaveRequestsModal(true)}
//               className="w-full bg-yellow-600 hover:bg-yellow-700 text-white font-medium py-2 px-4 rounded-lg transition"
//             >
//               Review Requests
//             </button>
//           </div>

//           {/* Pending Attendance Corrections */}
//           <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg shadow-sm border border-orange-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center">
//                   <Clock className="w-6 h-6 text-white" />
//                 </div>
//                 <div>
//                   <h3 className="text-lg font-semibold text-orange-900">
//                     Attendance Corrections
//                   </h3>
//                   <p className="text-xs text-orange-700">Pending review</p>
//                 </div>
//               </div>
//               <span className="text-3xl font-bold text-orange-700">
//                 {teamStats.pendingAttendanceCorrections}
//               </span>
//             </div>
//             <button className="w-full bg-orange-600 hover:bg-orange-700 text-white font-medium py-2 px-4 rounded-lg transition">
//               Review Corrections
//             </button>
//           </div>
//         </div>

//         {/* Pending Leave Requests Section */}
//         <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-lg font-semibold text-gray-800 flex items-center">
//               <FileText className="w-5 h-5 mr-2 text-indigo-600" />
//               Recent Leave Requests
//             </h2>
//             <span className="bg-red-100 text-red-800 text-xs font-semibold px-3 py-1 rounded-full">
//               {pendingLeaves.length} Pending
//             </span>
//           </div>
//           <div className="space-y-4">
//             {pendingLeaves.slice(0, 2).map((leave) => (
//               <div
//                 key={leave.id}
//                 className="border rounded-lg p-4 hover:bg-gray-50 transition"
//               >
//                 <div className="flex items-start justify-between mb-3">
//                   <div className="flex items-start space-x-3">
//                     <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
//                       <User className="w-5 h-5 text-indigo-600" />
//                     </div>
//                     <div>
//                       <h3 className="font-semibold text-gray-800">
//                         {leave.empName}
//                       </h3>
//                       <p className="text-xs text-gray-500">
//                         Emp ID: {leave.empId} • Applied on {leave.appliedOn}
//                       </p>
//                     </div>
//                   </div>
//                   <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-3 py-1 rounded-full border border-yellow-300">
//                     Pending
//                   </span>
//                 </div>
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3 text-sm">
//                   <div>
//                     <p className="text-xs text-gray-500">Leave Type</p>
//                     <p className="font-medium text-gray-800">
//                       {leave.leaveType}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-xs text-gray-500">From Date</p>
//                     <p className="font-medium text-gray-800">
//                       {leave.fromDate}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-xs text-gray-500">To Date</p>
//                     <p className="font-medium text-gray-800">{leave.toDate}</p>
//                   </div>
//                   <div>
//                     <p className="text-xs text-gray-500">Total Days</p>
//                     <p className="font-medium text-gray-800">
//                       {leave.days} day{leave.days > 1 ? "s" : ""}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="mb-3">
//                   <p className="text-xs text-gray-500 mb-1">Reason</p>
//                   <p className="text-sm text-gray-700">{leave.reason}</p>
//                 </div>
//                 <div className="flex space-x-3">
//                   <button
//                     onClick={() => handleApprove(leave.id)}
//                     className="flex-1 bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center"
//                   >
//                     <CheckCircle className="w-4 h-4 mr-2" />
//                     Approve
//                   </button>
//                   <button
//                     onClick={() => handleReject(leave.id)}
//                     className="flex-1 bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center"
//                   >
//                     <XCircle className="w-4 h-4 mr-2" />
//                     Reject
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//           <div className="mt-4 text-center">
//             <button
//               onClick={() => setShowLeaveRequestsModal(true)}
//               className="text-indigo-600 hover:text-indigo-700 text-sm font-medium"
//             >
//               View All Leave Requests →
//             </button>
//           </div>
//         </div>

//         {/* Team Members Overview */}
//         <div className="bg-white rounded-lg shadow-sm border p-6">
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-lg font-semibold text-gray-800 flex items-center">
//               <Users className="w-5 h-5 mr-2 text-indigo-600" />
//               Team Members
//             </h2>
//             <button
//               onClick={() => setShowTeamMembersModal(true)}
//               className="text-indigo-600 hover:text-indigo-700 text-sm font-medium"
//             >
//               View All →
//             </button>
//           </div>
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead>
//                 <tr className="border-b">
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     EMP ID
//                   </th>
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     Name
//                   </th>
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     Designation
//                   </th>
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     Status
//                   </th>
//                   <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                     Action
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {teamMembers.slice(0, 4).map((member) => (
//                   <tr
//                     key={member.id}
//                     className="border-b hover:bg-gray-50 transition"
//                   >
//                     <td className="py-3 px-4 text-sm text-gray-800">
//                       {member.empId}
//                     </td>
//                     <td className="py-3 px-4 text-sm font-medium text-gray-800">
//                       {member.name}
//                     </td>
//                     <td className="py-3 px-4 text-sm text-gray-600">
//                       {member.designation}
//                     </td>
//                     <td className="py-3 px-4">
//                       <span
//                         className={`text-sm font-medium ${member.statusColor}`}
//                       >
//                         {member.status}
//                       </span>
//                     </td>
//                     <td className="py-3 px-4">
//                       <button
//                         onClick={() => handleViewProfile(member)}
//                         className="text-indigo-600 hover:text-indigo-700 text-sm font-medium"
//                       >
//                         View Profile
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* Add Employee Modal */}
//       {showAddEmployeeModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-xl font-bold text-gray-800">
//                 Add New Employee
//               </h3>
//               <button
//                 onClick={() => setShowAddEmployeeModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="w-6 h-6" />
//               </button>
//             </div>
//             <form onSubmit={handleAddEmployeeSubmit} className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Employee ID *
//                 </label>
//                 <input
//                   type="text"
//                   name="empId"
//                   value={newEmployee.empId}
//                   onChange={handleAddEmployeeChange}
//                   required
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   placeholder="Enter employee ID"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Employee Name *
//                 </label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={newEmployee.name}
//                   onChange={handleAddEmployeeChange}
//                   required
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   placeholder="Enter full name"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Email ID *
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={newEmployee.email}
//                   onChange={handleAddEmployeeChange}
//                   required
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   placeholder="Enter email address"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Phone Number *
//                 </label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={newEmployee.phone}
//                   onChange={handleAddEmployeeChange}
//                   required
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   placeholder="Enter phone number"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Designation *
//                 </label>
//                 <input
//                   type="text"
//                   name="designation"
//                   value={newEmployee.designation}
//                   onChange={handleAddEmployeeChange}
//                   required
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   placeholder="Enter designation"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Department *
//                 </label>
//                 <input
//                   type="text"
//                   name="department"
//                   value={newEmployee.department}
//                   onChange={handleAddEmployeeChange}
//                   required
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   placeholder="Enter department"
//                 />
//               </div>
//               <div className="flex space-x-3 pt-2">
//                 <button
//                   type="button"
//                   onClick={() => setShowAddEmployeeModal(false)}
//                   className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 font-medium transition"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-medium transition"
//                 >
//                   Add Employee
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Leave Requests Modal */}
//       {showLeaveRequestsModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-xl p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
//             <div className="flex items-center justify-between mb-6">
//               <h3 className="text-2xl font-bold text-gray-800">
//                 Pending Leave Requests
//               </h3>
//               <button
//                 onClick={() => setShowLeaveRequestsModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="w-6 h-6" />
//               </button>
//             </div>
//             <div className="space-y-4">
//               {pendingLeaves.length === 0 ? (
//                 <div className="text-center py-12">
//                   <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
//                   <p className="text-gray-500 text-lg">
//                     No pending leave requests
//                   </p>
//                 </div>
//               ) : (
//                 pendingLeaves.map((leave) => (
//                   <div
//                     key={leave.id}
//                     className="border rounded-lg p-4 hover:bg-gray-50 transition"
//                   >
//                     <div className="flex items-start justify-between mb-3">
//                       <div className="flex items-start space-x-3">
//                         <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
//                           <User className="w-5 h-5 text-indigo-600" />
//                         </div>
//                         <div>
//                           <h3 className="font-semibold text-gray-800">
//                             {leave.empName}
//                           </h3>
//                           <p className="text-xs text-gray-500">
//                             Emp ID: {leave.empId} • Applied on {leave.appliedOn}
//                           </p>
//                         </div>
//                       </div>
//                       <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-3 py-1 rounded-full border border-yellow-300">
//                         Pending
//                       </span>
//                     </div>
//                     <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3 text-sm">
//                       <div>
//                         <p className="text-xs text-gray-500">Leave Type</p>
//                         <p className="font-medium text-gray-800">
//                           {leave.leaveType}
//                         </p>
//                       </div>
//                       <div>
//                         <p className="text-xs text-gray-500">From Date</p>
//                         <p className="font-medium text-gray-800">
//                           {leave.fromDate}
//                         </p>
//                       </div>
//                       <div>
//                         <p className="text-xs text-gray-500">To Date</p>
//                         <p className="font-medium text-gray-800">
//                           {leave.toDate}
//                         </p>
//                       </div>
//                       <div>
//                         <p className="text-xs text-gray-500">Total Days</p>
//                         <p className="font-medium text-gray-800">
//                           {leave.days} day{leave.days > 1 ? "s" : ""}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="mb-3">
//                       <p className="text-xs text-gray-500 mb-1">Reason</p>
//                       <p className="text-sm text-gray-700">{leave.reason}</p>
//                     </div>
//                     <div className="flex space-x-3">
//                       <button
//                         onClick={() => handleApprove(leave.id)}
//                         className="flex-1 bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center"
//                       >
//                         <CheckCircle className="w-4 h-4 mr-2" />
//                         Approve
//                       </button>
//                       <button
//                         onClick={() => handleReject(leave.id)}
//                         className="flex-1 bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center"
//                       >
//                         <XCircle className="w-4 h-4 mr-2" />
//                         Reject
//                       </button>
//                     </div>
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Team Members Modal */}
//       {showTeamMembersModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-xl p-6 w-full max-w-6xl max-h-[90vh] overflow-y-auto">
//             <div className="flex items-center justify-between mb-6">
//               <h3 className="text-2xl font-bold text-gray-800">
//                 All Team Members
//               </h3>
//               <button
//                 onClick={() => setShowTeamMembersModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="w-6 h-6" />
//               </button>
//             </div>
//             <div className="overflow-x-auto">
//               <table className="w-full">
//                 <thead>
//                   <tr className="border-b-2 border-gray-200">
//                     <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                       EMP ID
//                     </th>
//                     <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                       Name
//                     </th>
//                     <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                       Email
//                     </th>
//                     <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                       Designation
//                     </th>
//                     <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                       Status
//                     </th>
//                     <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
//                       Action
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {teamMembers.map((member) => (
//                     <tr
//                       key={member.id}
//                       className="border-b hover:bg-gray-50 transition"
//                     >
//                       <td className="py-3 px-4 text-sm text-gray-800">
//                         {member.empId}
//                       </td>
//                       <td className="py-3 px-4 text-sm font-medium text-gray-800">
//                         {member.name}
//                       </td>
//                       <td className="py-3 px-4 text-sm text-gray-600">
//                         {member.email}
//                       </td>
//                       <td className="py-3 px-4 text-sm text-gray-600">
//                         {member.designation}
//                       </td>
//                       <td className="py-3 px-4">
//                         <span
//                           className={`text-sm font-medium ${member.statusColor}`}
//                         >
//                           {member.status}
//                         </span>
//                       </td>
//                       <td className="py-3 px-4">
//                         <button
//                           onClick={() => {
//                             setShowTeamMembersModal(false);
//                             handleViewProfile(member);
//                           }}
//                           className="text-indigo-600 hover:text-indigo-700 text-sm font-medium"
//                         >
//                           View Profile
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Employee Profile Modal */}
//       {showProfileModal && selectedEmployee && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-xl p-6 w-full max-w-2xl">
//             <div className="flex items-center justify-between mb-6">
//               <h3 className="text-2xl font-bold text-gray-800">
//                 Employee Profile
//               </h3>
//               <button
//                 onClick={() => {
//                   setShowProfileModal(false);
//                   setSelectedEmployee(null);
//                 }}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="w-6 h-6" />
//               </button>
//             </div>

//             {/* Profile Header */}
//             <div className="flex items-center space-x-4 mb-6 pb-6 border-b">
//               <div className="w-20 h-20 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
//                 {selectedEmployee.name
//                   .split(" ")
//                   .map((n) => n[0])
//                   .join("")
//                   .toUpperCase()}
//               </div>
//               <div>
//                 <h4 className="text-xl font-bold text-gray-800">
//                   {selectedEmployee.name}
//                 </h4>
//                 <p className="text-sm text-gray-500">
//                   {selectedEmployee.designation}
//                 </p>
//                 <span
//                   className={`inline-block mt-2 text-sm font-medium ${selectedEmployee.statusColor}`}
//                 >
//                   ● {selectedEmployee.status}
//                 </span>
//               </div>
//             </div>

//             {/* Profile Details */}
//             <div className="grid grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">
//                   Employee ID
//                 </label>
//                 <p className="text-base font-medium text-gray-800">
//                   {selectedEmployee.empId}
//                 </p>
//               </div>
//               <div>
//                 <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">
//                   Department
//                 </label>
//                 <p className="text-base font-medium text-gray-800">
//                   {selectedEmployee.department}
//                 </p>
//               </div>
//               <div>
//                 <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">
//                   Email Address
//                 </label>
//                 <p className="text-base font-medium text-gray-800">
//                   {selectedEmployee.email}
//                 </p>
//               </div>
//               <div>
//                 <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">
//                   Phone Number
//                 </label>
//                 <p className="text-base font-medium text-gray-800">
//                   {selectedEmployee.phone}
//                 </p>
//               </div>
//               <div>
//                 <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">
//                   Designation
//                 </label>
//                 <p className="text-base font-medium text-gray-800">
//                   {selectedEmployee.designation}
//                 </p>
//               </div>
//               <div>
//                 <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">
//                   Joining Date
//                 </label>
//                 <p className="text-base font-medium text-gray-800">
//                   {selectedEmployee.joiningDate}
//                 </p>
//               </div>
//             </div>

//             {/* Action Buttons */}
//             <div className="mt-6 pt-6 border-t flex space-x-3">
//               <button className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2.5 px-4 rounded-lg transition">
//                 View Attendance
//               </button>
//               <button className="flex-1 bg-white hover:bg-gray-50 text-gray-700 font-medium py-2.5 px-4 rounded-lg border-2 border-gray-200 transition">
//                 View Leave History
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ManagerDashboard;
